import { z } from 'zod'

export const ZResetPasswordForm = z
  .object({
    newPassword: z
      .string()
      .trim()
      .min(1, {
        message: '비밀번호를 입력해 주세요.',
      })
      .regex(/^(?=.*[a-zA-Z])(?=.*\d).{6,15}$/, {
        message: '영문, 숫자 조합 6자-15자로 입력해 주세요.',
      }),
    newPasswordConfirm: z.string().trim().min(1, {
      message: '비밀번호를 확인해 주세요.',
    }),
  })
  .refine(data => data.newPassword === data.newPasswordConfirm, {
    message: '비밀번호가 일치하지 않습니다.',
    path: ['newPasswordConfirm'],
  })

export type TResetPasswordForm = z.infer<typeof ZResetPasswordForm>

export const defaultValues: TResetPasswordForm = {
  newPassword: '',
  newPasswordConfirm: '',
}
